import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { VhAlgorithm, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'app-add-sub-menu-vertical-admin',
  templateUrl: './add-sub-menu-vertical-admin.component.html',
  styleUrls: ['./add-sub-menu-vertical-admin.component.scss']
})

export class AddSubMenuVerticalAdminComponent implements OnInit {
  @Input() data: any;
  @Output() isCancelFormAddSub = new EventEmitter();
  @Output() valueDataAdd = new EventEmitter();
  @Output() getDataCategoryAgain = new EventEmitter();

  // Mảng danh sách type (none/link-page/website/link-url/category)
  listLink = [
    {
      url: 'link-page',
      name: 'den_trang'
    },
    {
      url: 'website',
      name: 'lien_ket'
    },
    {
      url: 'link-url',
      name: 'link_san_pham'
    }
  ];
  
  listLinkPage = []; // biến chứa dữ liệu các Trang liên kết (link-page)
  listPageCategory: any = []; // biến chứa dữ liệu các Trang danh mục (category)
  listPageCategorySelected = new FormControl([]); // biến này chứa các danh mục được add
  isValid = true; // Biến này xác định form đã valid hay chưa (true: valid; false: chưa)

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhAlgorithm: VhAlgorithm,
    public functionService: FunctionService,
  ) {
  }

  ngOnInit(): void {
    // Lấy dữ liệu
    this.getLinkPage();
    this.getCategorySteps();
    this.checkEditCateSelected();
  }

  /**
   * Lấy danh sách các Trang liên kết (link-page)
   */
  getLinkPage() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $in: ['blank', 'homepage', 'detail_category'] } }).then((pages:any) => {
      Promise.all(
        pages.map((page: any) => {
          return this.vhQueryAutoWeb.getCommonDatas_byFields({ id_page: { $eq: page._id } })
            .then((commonData) => {
              page.link = commonData[0]?.link ?? page.link;
              page.name = commonData[0]?.name ?? page.name;
              return page; // Trả về page sau khi cập nhật
            });
        })
      ).then((updatedPages) => {
        this.listLinkPage = updatedPages;
      })
    });
  }

  /**
   * Kiểm tra danh mục được chọn
   */
  checkEditCateSelected() {
    if(this.data.item.subData){
      this.data.item?.subData.forEach((data) => {
        if(data.listPageCategorySelected) {
          this.data.childMenu.listPageCategorySelected = data.listPageCategorySelected;
        }
      })
    }
  }

  /**
   * Lấy danh sách các Trang danh mục (category)
   */
  getCategorySteps() {
    this.vhQueryAutoWeb.getCategorySteps_byIdFatherCategory("", {}, {})
      .then((response: any) => {
        if (response.vcode === 0) {
          this.listPageCategory = response.data;
        }
      }, (error: any) => {
      })
  }

  /**
   * Bắt sự kiện thay đổi loại link (type)
   */
  changeType(){
    // reset các trường
    this.data.childMenu.id_page_category = null;
    // this.data.menu.id_freeblock = null;
    this.data.childMenu.link_page = null;
    this.data.childMenu.link_website = null;
    this.data.childMenu.link_url = null;
    this.onChangeAttr();
  }

  /**
   * Bắt sự kiện thay đổi các trường trong from khi thêm menu con cho groupParent là link
   */
  onChangeAttr() {
    const menu = this.data.childMenu;

    setTimeout(() => {
      if (!menu) return;

      const isValidBody =
          (menu.type === 'none') ||
          (menu.type === 'link-page' && menu.link_page != null) ||
          (menu.type === 'website' && menu.link_website) ||
          (menu.type === 'link-url' && menu.link_url);

      const isValidLink = (menu.groupParent != 'category' && isValidBody);
      
      this.isValid = menu['name_' + this.functionService.selectedLanguageCode] && isValidLink;
    }, 50)
  }

  /**
   * Bắt sự kiện thay đổi danh mục khi thêm menu con cho groupParent là category
   */
  onChange(value: any) {
    if(value.length > 0) this.isValid = true;
    else this.isValid = false;
  }

  /**
   * Lưu giá trị form thêm menu con và truyền về đi giao diện hiển thị
   */
  saveValueDataAdd() {
    // Xóa các trường không cần
    const menu = this.data.childMenu;
    // Xóa theo type
    const typeFieldsToDeleteMap = {
      'none': ['link_page', 'link_website', 'link_url'],
      'link-page': ['link_website', 'link_url'],
      'website': ['link_page', 'link_url'],
      'link-url': ['link_website', 'link_page']
    };
    // Xóa theo group
    const groupFieldsToDeleteMap = {
      'link': ['id_page_category', 'id_freeblock'],
      'category': ['id_freeblock'],
      'pop-up': ['id_page_category']
    };
    // Mảng chứa các trường cần xóa
    const fieldsToDelete = typeFieldsToDeleteMap[menu.type] || [];
    fieldsToDelete.push(...groupFieldsToDeleteMap[menu.group] || []);
    // Xóa
    this.deleteFields(menu, fieldsToDelete);
    

    
    if (this.data.item.group === "category") {
      this.data.subData = [];
      if(this.data.item.subData) {
        this.data.item.subData.forEach((data) => {
          if(data.listPageCategorySelected) {
            this.data.subData.push(data);
          }
        })
      }
    }
    else {
      this.data.childMenu = {
        ...this.data.childMenu,
        level: this.data.item.level+1,
        _id :  this.vhAlgorithm.ObjectId(),
        children: []
      }
    }

    console.log(this.data);


    // Gửi dữ liệu đi
    this.valueDataAdd.emit(this.data);
    this.isCancelFormAddSub.emit(false);
    this.getDataCategoryAgain.emit(true);
  }
  
  /**
   * Xóa các trường trong object
   * @param {Object} data - Object có trường cần xóa
   * @param {Array} fieldsToDelete - Mảng chứa tên các trường cần xóa
   */
  deleteFields(data, fieldsToDelete) {
    fieldsToDelete.forEach(field => {
      delete data[field];
    });
  }
  
  /**
   * Đóng form thêm menu con
   */
  cancleFormAddSub() {
    this.isCancelFormAddSub.emit(false);
  }
  
}
